/*
 * @Author: 小周
 * @Date: 2024-06-17 15:19:27
 * @LastEditTime: 2024-07-02 10:25:45
 * @LastEditors: MrZHLF
 * @Description:
 */
import { useState } from 'react'
import { Popup, Input, Toast } from 'react-vant'
import { addComment } from '@/api/comment'
import styles from './index.module.scss'
import { getUser } from '@/utils/userStore'
const CommentPopup = ({
  visible,
  onClose,
  updateList,
  commentObj,
  article,
}) => {
  const [center, setCenter] = useState('')
  const close = () => {
    onClose()
    setCenter('')
  }

  const submit = () => {
    if (center == '') {
      Toast('内容不能为空')
      return
    }
    let userInfo = getUser()
    let user_icon = 'https://static.hntv.tv/total/tsb/dxrx/static/user.png'
    let data = {
      commentUserIcon: (userInfo && userInfo.icon) || user_icon, //用户头像
      commentUserNickname: userInfo && userInfo.nickname, //用户昵称
      content: center, //评论内容
      objectId: article.objectId, //文章ID
      objectTitle: article.objectTitle, //文章标题
      parentCommentId: commentObj.commentId ? commentObj.commentId : '', //回复的commentId
      publishFirst: commentObj.publishFirst || true, //false 先申后发
      replyToComment: commentObj.commentId ? commentObj.commentId : '', //回复的commentId
      replyToUserId: commentObj.commentUserId ? commentObj.commentUserId : '', //回复的commentUserId
      source: commentObj.source || 1, //1-网页，2-h5，3-app，4-微信
      appFusionId: commentObj.appFusionId || '1390195608019869697', //appid
      moudleId: commentObj.moudleId || '1392047446073212929', //栏目ID
      typeId: article.typeId || '1392047446073212929', //1：稿件评论，2：直播评论，其他业务请咨询开发。
    }
    console.log(data, '00000')
    addComment(data).then((res) => {
      if (res.code == 0 && res.result) {
        updateList()
        Toast('评论成功')
        close()
      } else {
        Toast(res.msg)
      }
    })
  }

  return (
    <Popup visible={visible} position="bottom" round style={{ height: '40%' }}>
      <div className={styles['comment-popup_wrap']}>
        <div className={styles.header}>
          <div className={styles.close}>
            <img
              onClick={close}
              className={styles.icon}
              src={require('./../../assets/images/close_icon.png')}
              alt=""
            />
          </div>
          <div className={styles.title}>添加评论</div>
          <div className={styles.btn}>
            <button className={styles.btn_sub} onClick={submit}>
              提交
            </button>
          </div>
        </div>
        <div className={styles.center}>
          <Input.TextArea
            onChange={setCenter}
            placeholder="请输入评论内容~~"
            className={styles.center_text}
            autoSize={{ minHeight: 130 }}
          />
        </div>
      </div>
    </Popup>
  )
}

export default CommentPopup
